import FallbackImage from '@/components/common/FallbackImage'
import ListPagination from '@/components/common/ListPagination.vue'
import { NO_GROUP_KEY, smenuOptGroupsOf } from '@/utils/smenuOptGroups'

export default {
  install(Vue) {
    Vue.component('fallback-image', FallbackImage)
    // 목록 화면의 페이지 UI — `el-pagination` 을 화면마다 다시 적지 않는다(`mixins/pagedListMixin` 와 한 쌍)
    Vue.component('list-pagination', ListPagination)
    // `disabled` — `code-combo` 와 같은 모양(읽기 전용 칸: 대행 계정의 매장 사용 여부 등)
    Vue.component('combo', {
      props: ['model', 'label', 'data', 'disabled'],
      template:
        '<el-select :value="model" @change="handleChange" style="width: 100%;" :disabled="disabled">' +
        '	<el-option key="" :label="label" value="" v-if="undefined == label ? false : true"></el-option>' +
        '	<el-option v-for="item in data" :key="item.value" :label="item.label" :value="item.value"></el-option>' +
        '</el-select>',
      methods: {
        handleChange: function (val) {
          this.$emit('change', val)
        },
      },
    })

    Vue.component('mcombo', {
      props: ['model', 'label', 'data'],
      template:
        '<el-select :value="model" multiple @change="handleChange" style="width: 100%;">' +
        '	<el-option key="" :label="label" value="" v-if="undefined == label ? false : true"></el-option>' +
        '	<el-option v-for="item in data" :key="item.value" :label="item.label" :value="item.value"></el-option>' +
        '</el-select>',
      methods: {
        handleChange: function (val) {
          this.$emit('change', val)
        },
      },
    })

    Vue.component('code-combo', {
      props: ['model', 'label', 'data', 'disabled'],
      template:
        '<el-select :value="modelVal" @change="handleChange" style="width: 100%;" :disabled="disabled">' +
        '	<el-option key=0 :label="label" :value=0 v-if="undefined == label ? false : true"></el-option>' +
        '	<el-option v-for="item in data" :key="item.cd" :label="item.nmLan" :value="item.cd"></el-option>' +
        '</el-select>',
      computed: {
        modelVal: function () {
          if (null != this.model) {
            if (typeof this.model == 'object' && !Array.isArray(this.model)) {
              return this.model.cd
            } else {
              return this.model
            }
          } else {
            return ''
          }
        },
      },
      methods: {
        handleChange: function (val) {
          for (var i = 0, len = this.data.length; i < len; i++) {
            if (this.data[i].cd == val) {
              this.$emit('change', this.data[i])
              return
            }
          }

          this.$emit('change', { cd: val })
        },
      },
    })

    Vue.component('mcode-combo', {
      props: ['model', 'label', 'data', 'disabled'],
      template:
        '<el-select :value="modelVal" multiple @change="handleChange" :disabled="undefined == disabled ? false : disabled" style="width: 100%;">' +
        '	<el-option key=0 :label="label" :value=0 v-if="undefined == label ? false : true"></el-option>' +
        '	<el-option v-for="item in data" :key="item.cd" :label="item.nmLan" :value="item.cd"></el-option>' +
        '</el-select>',
      computed: {
        modelVal: function () {
          var tmpVal = []

          if (null != this.model) {
            for (var i = 0, len = this.model.length; i < len; i++) {
              tmpVal.push(this.model[i].cd)
            }
          }
          return tmpVal
        },
      },
      methods: {
        handleChange: function (val) {
          var returnVal = []

          for (var i = 0, len = this.data.length; i < len; i++) {
            for (var j = 0, jlen = val.length; j < jlen; j++) {
              if (this.data[i].cd == val[j]) {
                returnVal.push(this.data[i])
              }
            }
          }

          this.$emit('change', returnVal)
        },
      },
    })

    Vue.component('lan-combo', {
      props: ['model', 'label', 'data'],
      template:
        '<el-select :value="model" @change="handleChange" style="width: 100%;">' +
        '	<el-option key="" :label="label" value="" v-if="undefined == label ? false : true"></el-option>' +
        '	<el-option v-for="item in data" :key="item.id" :label="item.nm" :value="item.id"></el-option>' +
        '</el-select>',
      methods: {
        handleChange: function (val) {
          this.$emit('change', val)
        },
      },
    })

    Vue.component('lans-combo', {
      props: ['model', 'label', 'data', 'disable_id'],
      template:
        '<el-select :value="modelVal" multiple @change="handleChange" style="width: 100%;">' +
        '	<el-option key="" :label="label" value="" v-if="undefined == label ? false : true"></el-option>' +
        '	<el-option v-for="item in data" :key="item.id" :label="item.nm" :value="item.id" :disabled="item.id == disable_id"></el-option>' +
        '</el-select>',
      computed: {
        modelVal: function () {
          var tmpVal = []
          for (var i = 0, len = this.model.length; i < len; i++) {
            tmpVal.push(this.model[i].id)
          }

          return tmpVal
        },
      },
      methods: {
        handleChange: function (val) {
          var returnVal = []

          for (var i = 0, len = this.data.length; i < len; i++) {
            for (var j = 0, jlen = val.length; j < jlen; j++) {
              if (this.data[i].id == val[j]) {
                returnVal.push(this.data[i])
              }
            }
          }

          this.$emit('change', returnVal)
        },
      },
    })

    Vue.component('category-combo', {
      props: ['model', 'data'],
      template:
        '<el-select :value="modelVal" multiple @change="handleChange" style="width: 100%;">' +
        '	<el-option v-for="item in data" :key="item.categoryCd" :label="item.categoryNm" :value="item.categoryCd"></el-option>' +
        '</el-select>',
      computed: {
        modelVal: function () {
          var tmpVal = []

          if (null != this.model) {
            for (var i = 0, len = this.model.length; i < len; i++) {
              tmpVal.push(this.model[i].categoryCd)
            }
          }
          return tmpVal
        },
      },
      methods: {
        handleChange: function (val) {
          var returnVal = []

          for (var i = 0, len = this.data.length; i < len; i++) {
            for (var j = 0, jlen = val.length; j < jlen; j++) {
              if (this.data[i].categoryCd == val[j]) {
                returnVal.push(this.data[i])
              }
            }
          }

          this.$emit('change', returnVal)
        },
      },
    })

    Vue.component('opt-tp-combo', {
      props: ['model', 'label', 'data'],
      template:
        '<el-select :value="model" @change="handleChange" style="width: 100%;">' +
        '	<el-option key="" :label="label" value="" v-if="undefined == label ? false : true"></el-option>' +
        '	<el-option v-for="item in data" :key="item.smenuOptTpCd" :label="item.optTp.nmLan + \' - \' + item.smenuOptTpNm" :value="item.smenuOptTpCd">' +
        '		<span>{{ item.optTp.nmLan + " - " + item.smenuOptTpNm }}</span>' +
        '	</el-option>' +
        '</el-select>',
      methods: {
        handleChange: function (val) {
          this.$emit('change', val)
        },
      },
    })

    Vue.component('opt-combo', {
      props: ['model', 'data'],
      template:
        '<el-select :value="modelVal" multiple @change="handleChange" style="width: 100%;">' +
        '	<el-option-group v-for="grp in groups" :key="grp.tpCd" :label="grp.label">' +
        '		<el-option v-for="item in grp.items" :key="item.smenuOptCd" :label="item.smenuOptNm + \' - \' + grp.label" :value="item.smenuOptCd">' +
        '			<span>{{ item.smenuOptNm + (item.price > 0 ? "(+" + item.price + ")" : "") + " - " + grp.label }}</span>' +
        '		</el-option>' +
        '	</el-option-group>' +
        '</el-select>',
      computed: {
        modelVal: function () {
          var tmpVal = []

          if (null != this.model) {
            for (var i = 0, len = this.model.length; i < len; i++) {
              tmpVal.push(this.model[i].smenuOptCd)
            }
          }
          return Array.from(new Set(tmpVal)) // 중복 제거
        },
        // 옵션을 소속 옵션그룹별로 묶는다 — 규칙은 `utils/smenuOptGroups` 한 곳이 소유한다
        groups: function () {
          return smenuOptGroupsOf(this.data)
        },
      },
      methods: {
        handleChange: function (val) {
          var returnVal = []

          for (var i = 0, len = this.data.length; i < len; i++) {
            for (var j = 0, jlen = val.length; j < jlen; j++) {
              if (this.data[i].smenuOptCd == val[j]) {
                returnVal.push(this.data[i])
              }
            }
          }

          this.$emit('change', returnVal)
        },
      },
    })

    // 메뉴 옵션 선택 — 옵션그룹 담기 + 개별 옵션 추가 + 선택 요약(그룹 전체 선택 시 그룹 칩 1개로 접기)
    //  model = 선택된 옵션(SmenuOpt) 배열, data = 매장 활성 옵션 전체(평면 그룹 축 `smenuOptTpCd` 포함)
    //  백엔드 저장은 기존과 동일한 평면 옵션 리스트 유지 — 표시만 그룹 단위로 접는다(하위호환)
    Vue.component('opt-select', {
      props: ['model', 'data'],
      data: function () {
        return { groupPick: '', optPick: '' }
      },
      computed: {
        // data(매장 옵션)를 소속 그룹별로 묶는다 — 규칙은 `utils/smenuOptGroups` 한 곳이 소유한다
        groups: function () {
          return smenuOptGroupsOf(this.data)
        },
        // 그룹 담기 드롭다운 — 그룹 없는 항목은 통째 담기 대상이 아니므로 제외
        addableGroups: function () {
          return this.groups.filter(function (g) {
            return g.tpCd !== NO_GROUP_KEY
          })
        },
        dataByCd: function () {
          var m = {}
          var list = this.data || []
          for (var i = 0, len = list.length; i < len; i++) m[list[i].smenuOptCd] = list[i]
          return m
        },
        // 선택 요약: 그룹의 활성 옵션이 전부 선택되면 그룹 칩으로 접고, 나머지는 개별 옵션 칩
        summary: function () {
          var selected = this.model || []
          var sel = {}
          for (var i = 0; i < selected.length; i++) sel[selected[i].smenuOptCd] = true

          var covered = {}
          var groupChips = []
          for (var g = 0, glen = this.groups.length; g < glen; g++) {
            var grp = this.groups[g]
            if (grp.tpCd === NO_GROUP_KEY || !grp.items.length) continue
            var all = true
            for (var k = 0; k < grp.items.length; k++) {
              if (!sel[grp.items[k].smenuOptCd]) {
                all = false
                break
              }
            }
            if (all) {
              groupChips.push({ tpCd: grp.tpCd, label: grp.label, count: grp.items.length })
              for (var c = 0; c < grp.items.length; c++) covered[grp.items[c].smenuOptCd] = true
            }
          }

          var looseChips = []
          for (var s = 0; s < selected.length; s++) {
            var o = selected[s]
            if (covered[o.smenuOptCd]) continue
            var d = this.dataByCd[o.smenuOptCd]
            var nm = (d && (d.smenuOptNmLan || d.smenuOptNm)) || o.smenuOptNmLan || o.smenuOptNm || '#' + o.smenuOptCd
            looseChips.push({ smenuOptCd: o.smenuOptCd, nm: nm })
          }
          return { groupChips: groupChips, looseChips: looseChips }
        },
      },
      methods: {
        // 그룹 통째로 담기 — 소속 판정은 `groups` 가 이미 끝냈다(`onRemoveGroup` 과 같은 출처).
        // `data` 를 다시 훑으면 묶는 규칙이 두 벌이 되어, 한쪽만 고치는 날 담기와 빼기가 갈린다
        onAddGroup: function (tpCd) {
          if (!tpCd) return
          var group = this.groups.find(function (g) {
            return g.tpCd == tpCd
          })
          if (!group) return
          var exists = {}
          var next = (this.model || []).slice()
          for (var i = 0; i < next.length; i++) exists[next[i].smenuOptCd] = true
          for (var j = 0; j < group.items.length; j++) {
            var opt = group.items[j]
            if (!exists[opt.smenuOptCd]) {
              next.push(opt)
              exists[opt.smenuOptCd] = true
            }
          }
          this.groupPick = ''
          this.$emit('change', next)
        },
        onAddOpt: function (cd) {
          if (null == cd || '' === cd) return
          var exists = (this.model || []).some(function (o) {
            return o.smenuOptCd == cd
          })
          this.optPick = ''
          if (exists) return
          var opt = this.dataByCd[cd]
          if (opt) this.$emit('change', (this.model || []).concat([opt]))
        },
        onRemoveGroup: function (tpCd) {
          var group = this.groups.find(function (g) {
            return g.tpCd == tpCd
          })
          var groupOptCds = group
            ? group.items.map(function (o) {
                return o.smenuOptCd
              })
            : []

          this.$emit(
            'change',
            (this.model || []).filter(function (o) {
              return !groupOptCds.some(function (cd) {
                return cd == o.smenuOptCd
              })
            })
          )
        },
        onRemoveOpt: function (cd) {
          this.$emit(
            'change',
            (this.model || []).filter(function (o) {
              return o.smenuOptCd != cd
            })
          )
        },
      },
      template:
        '<div class="opt-select">' +
        '	<el-select :value="groupPick" :placeholder="$t(\'옵션그룹 담기\')" filterable style="width: 100%; margin-bottom: 6px;" @change="onAddGroup">' +
        '		<el-option v-for="g in addableGroups" :key="g.tpCd" :label="g.label + \' (\' + g.items.length + \'개 전체 담기)\'" :value="g.tpCd">' +
        '			<span>{{ g.label }} ({{ g.items.length }}개 전체 담기)</span>' +
        '		</el-option>' +
        '	</el-select>' +
        '	<el-select :value="optPick" :placeholder="$t(\'개별 옵션 추가\')" filterable style="width: 100%;" @change="onAddOpt">' +
        '		<el-option-group v-for="g in groups" :key="g.tpCd" :label="g.label">' +
        '			<el-option v-for="item in g.items" :key="item.smenuOptCd" :label="item.smenuOptNm + (item.price > 0 ? \'(+\' + item.price + \')\' : \'\') + \' - \' + g.label" :value="item.smenuOptCd"></el-option>' +
        '		</el-option-group>' +
        '	</el-select>' +
        '	<div class="opt-select__chips" style="margin-top: 6px; line-height: 1.9;">' +
        '		<el-tag v-for="gc in summary.groupChips" :key="\'g\' + gc.tpCd" type="primary" size="small" closable disable-transitions style="margin: 0 6px 4px 0;" @close="onRemoveGroup(gc.tpCd)">{{ gc.label }} · {{ gc.count }}{{ $t(\'개\') }}</el-tag>' +
        '		<el-tag v-for="oc in summary.looseChips" :key="\'o\' + oc.smenuOptCd" type="info" size="small" closable disable-transitions style="margin: 0 6px 4px 0;" @close="onRemoveOpt(oc.smenuOptCd)">{{ oc.nm }}</el-tag>' +
        '		<span v-if="!summary.groupChips.length && !summary.looseChips.length" style="color: #c0c4cc; font-size: 12px;">{{ $t(\'담긴 옵션이 없습니다\') }}</span>' +
        '	</div>' +
        '</div>',
    })

    Vue.component('stuff-combo', {
      props: ['model', 'data'],
      template:
        '<el-select :value="modelVal" multiple @change="handleChange" style="width: 100%;">' +
        '	<el-option v-for="item in data" :key="item.stuffCd" :label="item.stuffNm" :value="item.stuffCd">' +
        '		{{ item.stuffNm }} ' +
        '	</el-option>' +
        '</el-select>',
      computed: {
        modelVal: function () {
          var tmpVal = []

          if (null != this.model) {
            for (var i = 0, len = this.model.length; i < len; i++) {
              tmpVal.push(this.model[i].stuffCd)
            }
          }
          return tmpVal
        },
      },
      methods: {
        handleChange: function (val) {
          var returnVal = []

          for (var i = 0, len = this.data.length; i < len; i++) {
            for (var j = 0, jlen = val.length; j < jlen; j++) {
              if (this.data[i].stuffCd == val[j]) {
                returnVal.push(this.data[i])
              }
            }
          }

          this.$emit('change', returnVal)
        },
      },
    })

    Vue.component('discount-combo', {
      props: ['model', 'data'],
      template:
        '<el-select :value="modelVal" multiple @change="handleChange" style="width: 100%;">' +
        '	<el-option v-for="item in data" :key="item.discountCd" :label="item.discountNm" :value="item.discountCd"></el-option>' +
        '</el-select>',
      computed: {
        modelVal: function () {
          var tmpVal = []

          if (null != this.model) {
            for (var i = 0, len = this.model.length; i < len; i++) {
              tmpVal.push(this.model[i].discountCd)
            }
          }
          return tmpVal
        },
      },
      methods: {
        handleChange: function (val) {
          var returnVal = []

          for (var i = 0, len = this.data.length; i < len; i++) {
            for (var j = 0, jlen = val.length; j < jlen; j++) {
              if (this.data[i].discountCd == val[j]) {
                returnVal.push(this.data[i])
              }
            }
          }

          this.$emit('change', returnVal)
        },
      },
    })
  },
}
